var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanscapepolaroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.002C20.2091 14.002 22 12.2111 22 10.002C22 7.79281 20.2091 6.00195 18 6.00195C15.7909 6.00195 14 7.79281 14 10.002C14 12.2111 15.7909 14.002 18 14.002Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.824 21.766L28 14.002L34 26.002H14L20 18.002L22.824 21.766Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 32.002H38C39.106 32.002 40 31.106 40 30.002V2.00195C40 0.897953 39.106 0.00195312 38 0.00195312H10C8.894 0.00195312 8 0.897953 8 2.00195V30.002C8 31.106 8.894 32.002 10 32.002ZM36 28.002H12V4.00195H36V28.002Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 40.002H32V36.002H4V8.00195H0V38.002C0 39.106 0.894 40.002 2 40.002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanscapepolaroid);
export default __webpack_public_path__ + "static/media/Lanscape polaroid.315e06586f7ad6030ba37cc3c9183e47.svg";
export { ForwardRef as ReactComponent };